import React from 'react';
import { BadgeElement } from './styles';
import kinds from './kinds';
import sizes from './sizes';
export default function Badge({ children, kind = 'default', size = 0, textAlign = 'center', ...props }) {
    return (React.createElement(BadgeElement, Object.assign({ fontWeight: 500, textAlign: textAlign }, sizes[size], kinds[kind], props), children));
}
